import { observer } from "mobx-react-lite";
import { rootStore } from "../StApp";

export const ConfirmNextButton = observer(()=>{

    const shown = rootStore.dateshipStore.selectionMode === 'STANDARD'
    
    return(
        <button className='button-styled button-confirm-next'
          style={{display: shown? 'initial': 'none'}}
         onClick={()=>rootStore.dateshipStore.confirmChoices() } >Next</button>
    )
})